// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"52":"3e75cc0c68a078a2","53":"76444aea683525af","999":"10caffe3b221b30a"}[chunkId] + ".js";
};